import React from "react";
import PropTypes from "prop-types";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

const DeleteRuleDialog = ({ isDeleteDialogOpen, closeDialog, onDelete }) => (
  <Dialog
    isOpen={isDeleteDialogOpen}
    onUserDismiss={closeDialog}
    title={"Delete your savings rule"}
    footer={
      <Row alignItems="center" justifyContent="end">
        <Row.Item shrink>
          <Button onClick={closeDialog} kind="negative" label="Cancel" testId="cancel-delete-rule"/>
        </Row.Item>
        <Row.Item shrink>
          <Button
            onClick={onDelete}
            kind="primary"
            label="Yes, delete"
            testId="delete-rule"
          />
        </Row.Item>
      </Row>
    }
  >
    <div>{"Are you sure you want to delete your automatic savings rule?"}</div>
  </Dialog>
);
DeleteRuleDialog.propTypes = {
  isDeleteDialogOpen: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteRuleDialog;
